<template>
    <a @click.stop.prevent="zoomImage()" href="#!" data-title="Zoom">
        <i class="far fa-search-plus"></i>
    </a>
</template>

<script type="text/ecmascript-6">
    export default {
        methods:{
            zoomImage(){
                window.emitter.emit('zoom-button-clicked');
            }
        }
    }
</script>
